import { render, staticRenderFns } from "./iSpringQuizInfoView.vue?vue&type=template&id=761d97e2&"
import script from "./iSpringQuizInfoView.vue?vue&type=script&lang=js&"
export * from "./iSpringQuizInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports